import React, { memo } from "react";
import type { DiscoverPageItemDetail } from "@highnote/server/src/functions/handlers/discover/types";
import { MiniSpaceTile } from "../MiniSpaceTile";
import "./styles.scss";

export const HeroProfileTile = memo(
  ({
    itemDetail,
    featuredSpaceItemDetail,
  }: {
    itemDetail: DiscoverPageItemDetail | null;
    featuredSpaceItemDetail?: DiscoverPageItemDetail | null;
  }) => {
    return (
      <div className="hero-profile-tile">
        <div className="hero-profile-tile-inner">
          <div className="hero-profile-tile-avatar-column">
            {itemDetail?.squareImageUrl && (
              <img
                src={itemDetail.squareImageUrl}
                alt={itemDetail?.title ?? ""}
              />
            )}
          </div>
          <div className="hero-profile-tile-details">
            <div className="hero-profile-tile-text">
              {itemDetail?.title && (
                <span className="hero-profile-tile-name">
                  {itemDetail.title}
                </span>
              )}
              {itemDetail?.summary && (
                <span className="hero-profile-tile-summary">
                  {itemDetail.summary}
                </span>
              )}
            </div>
            {featuredSpaceItemDetail !== undefined && (
              <div className="hero-profile-tile-featured-space">
                <MiniSpaceTile itemDetail={featuredSpaceItemDetail} />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);
HeroProfileTile.displayName = "HeroProfileTile";
